import { TableBodyCell } from "../TableBodyCell";
import { Column } from "../types";
import styles from './styles.module.scss'


export type TableBodyProps<T extends Record<string, unknown>> = {
  data: T[];
  columns: Column<T>[];
  isDraggingEnabled?: boolean;
  onRowClick?: (rowData: T, rowIndex: number) => void;
  onRowRender?: (rowIndex: number) => React.HTMLAttributes<HTMLTableRowElement>;
};


export function TableBody<T extends Record<string, unknown>>({
  data,
  columns,
  isDraggingEnabled,
  onRowClick,
  onRowRender
}: TableBodyProps<T>) {

  const getRowProps = (index: number) => {
    if (!isDraggingEnabled || !onRowRender) {
      return {};
    }

    return onRowRender(index);
  };


  return (
    <tbody>
      {data.map((row, index) => {
        const rowProps = getRowProps(index);

        return (<tr key={index}
          className={onRowClick ? styles.rowClickable : ""}
          onClick={() => onRowClick?.(row, index)}
          {...rowProps}
          style={{ backgroundColor: index % 2 === 0 ? "rgba(156, 156, 156, 0.1)" : "#fff", cursor: onRowClick ? "pointer" : "default" }}
        >
          {columns.map((col) => (
            <TableBodyCell
              style={{
                width: col.width,
                textAlign: col.align ?? 'center',
                height: 56,
                paddingInline: 8,
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                color: "rgba(100, 99, 99, 1)",
              }}
              key={String(col.key)}
            >
              {col.Cell
                ? col.Cell(row, index)
                : String(row[col.key])}
            </TableBodyCell>
          ))}
        </tr>
        )
      })}
    </tbody>
  );
}